import { FontSizeEnum, FontWeightEnum, Typography } from '@acceso/design-system';
import clsx from 'clsx';

type TTableRowImageProp = {
  source?: string | null;
  alt: string;
  className?: string;
  name?: string;
  contentClassName?: string;
};
export function TableRowImage({
  source,
  className,
  contentClassName,
  alt,
  name,
}: TTableRowImageProp) {
  return (
    <div className={clsx(contentClassName, 'flex items-center gap-1')}>
      {source && (
        <img
          src={source}
          className={clsx(className, 'h-full max-h-[40px] max-w-[80px] object-contain')}
          alt={alt}
          title={alt}
        />
      )}
      {name && (
        <Typography fontSize={FontSizeEnum.Basic} weight={FontWeightEnum.Semibold}>
          {name}
        </Typography>
      )}
    </div>
  );
}
